import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import FormGLClosure from "./Form"

class UpdateGLClosure extends React.Component {

  componentDidMount() {
    const { params, setCurrentId, loadData, glClosure } = this.props
    setCurrentId(params.id);
    if(!glClosure) {
      loadData()
    }
  }

  render() {
    const { glClosure } = this.props;
    return glClosure ? <FormGLClosure glClosure={ glClosure } /> : <p>Loading ..</p>
  }
}

UpdateGLClosure.propTypes = {
  glClosure: PropTypes.object,
  setCurrentId: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const glClosure = DckSelectors.selectItemById(state, ItemTypes.GLClosure, ownProps.params.id)
  return { glClosure }
}

const mapDispatchToProps = dispatch => ({
  setCurrentId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.GLClosure, id)),
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.GLClosure)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateGLClosure)



// WEBPACK FOOTER //
// ./src/components/Accounting/GLClosures/Update.js